import type { Cage, Transit } from '../index.h'

import { createEvent, restore, sample } from 'effector'
import { createAction } from 'effector-action'
import { appearanceStylesFeature } from '~/features/appearance'
import { keys } from '~/shared/jail'
import { hallway } from './hallway'
import { hallway2profiles } from './hallway2profiles'

/*
 * ### Appearance Styles cage ###
 */

const init = createEvent<Transit>('init')
const seal = createEvent<boolean>('seal')

// out events
const gotoToa = createEvent('gotoToa')
const gotoProfiles = createEvent('gotoProfiles')

const out = createEvent()

export const appearanceStyles = {
  name: 'appearanceStyles',
  key: keys.lost,
  init: init,
  seal,
  in: [],
  out: {
    gotoToa,
    gotoProfiles,
  },
} satisfies Cage

/*
 * cage logic
 */

createAction({
  clock: out,
  source: restore(init, null),
  target: {
    gotoToa,
    gotoProfiles,
  },
  fn: (target, clock) => {
    switch (clock?.from) {
      case hallway:
        target.gotoToa()
        break
      case hallway2profiles:
        target.gotoProfiles()
        break
      default:
        target.gotoProfiles()
    }
  },
})

sample({
  clock: init,
  target: appearanceStylesFeature.init,
})

sample({
  source: appearanceStylesFeature.$ready,
  filter: Boolean,
  target: out,
})
